import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CellEditorComponentBase} from '@shared/components/cell-components/cell-component';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {map, startWith, take} from 'rxjs/operators';
import {State} from '@features/audit-tracker/models/audit-tracker.models';
import {PlatformCommand} from '@shared/commands/command-base';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {CommandService} from '@core/services/command.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'app-state-selector-cell-editor',
  templateUrl: './state-selector-cell-editor.component.html',
  styleUrls: ['./state-selector-cell-editor.component.scss']
})
export class StateSelectorCellEditorComponent extends CellEditorComponentBase implements OnInit {
  fieldDefinition: FieldDefinition;
  item: any;
  stateList: any[];
  selectedStateList: any[] = [];
  possibleNewState: boolean;
  stateFilteredOptions: Observable<any>;
  inputForm = new FormControl();
  @ViewChild('stateInput', {static: true}) stateInput: ElementRef;
  isStateAvailable: boolean;
  private newStateItem: any;

  constructor(private fuseSplashScreen: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private commandService: CommandService,
              private platformQueryService: PlatformQueryService) {
    super();
    this.isStateAvailable = false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getStates();
  }
  displayStateFn(state: any): string {
    return state && state.stateName ? state.stateName : '';
  }

  onAddState() {
    this.fuseSplashScreen.show();
    const command = new PlatformCommand('AddCustomStateCommand', 'AuditTrackerApi');
    command.fieldValues['StateName'] = this.newStateItem.stateName?.trim();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreen.hide();
      this.newStateItem = response.fieldValues['CustomState'];
      if (this.newStateItem == null) {
        this.snackBarService.showError('Can not Add Custom Audit Type');
      } else {
        this.stateList.push(this.newStateItem);
        this.inputForm.setValue(this.newStateItem);
        this.selectedOnAddCustomState(this.newStateItem);
      }
    }, err => {
      this.fuseSplashScreen.hide();
      this.snackBarService.showError(err.error.Message);
    });
  }

  remove(state: any): void {
    const index = this.selectedStateList.map(s => s.stateName.toLowerCase()).indexOf(state.stateName.toLowerCase());

    if (index >= 0) {
      this.selectedStateList.splice(index, 1);
    }
    this.emitOnValueChange();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.value;
    const index = this.selectedStateList.map(s => s.stateName.toLowerCase()).indexOf(value.stateName.toLowerCase());
    if (index === -1) {
      this.selectedStateList.push(value);
    }
    this.stateInput.nativeElement.value = '';
    this.inputForm.setValue('');
    this.emitOnValueChange();
    this.stateInput.nativeElement.blur();
  }
  selectedOnAddCustomState(newStateItem: any) {
    this.selectedStateList.push(newStateItem);
    this.stateInput.nativeElement.value = '';
    this.inputForm.setValue('');
    this.emitOnValueChange();
    this.stateInput.nativeElement.blur();
  }

  emitOnValueChange() {
    this.item.cells[this.fieldDefinition.key].value = this.selectedStateList.map(state => state.id);
    this.validationChange.emit(true);
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
  }

  private getStates() {
    this.fuseSplashScreen.show();
    const query = new PlatformQuery();
    query.api = 'AuditTrackerApi';
    query.name = 'StateQuery';
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreen.hide();
      if (response.fieldValues['States']) {
        this.stateList = response.fieldValues['States'];
        this.selectTheStateList();
        this.stateFilteredOptions = this.inputForm.valueChanges
          .pipe(
            startWith(''),
            map(value => {
              const {stateName} = value as State;
              return typeof value === 'string' ? value : stateName;
            }),
            map(name => name ? this._filterState(name) : this.stateList.slice())
          );
      }
      this.isStateAvailable = true;
    }, err => {
      this.fuseSplashScreen.hide();
      console.error('Can not fetch state information', err);
      this.isStateAvailable = false;
    });
  }

  private _filterState(value: any): State[] {
    const trimmedValue = value.trim();
    const filterValue = trimmedValue.toLowerCase();
    console.log(filterValue);
    const states = this.stateList.filter(state => state.stateName.toLowerCase().indexOf(filterValue) === 0);
    this.possibleNewState = !states.map(state => state.stateName.toLowerCase()).includes(filterValue);

    if (this.possibleNewState) {
      this.newStateItem = {
        stateName: trimmedValue,
        id: filterValue,
        stateCode: '',
        countryCode: ''
      };
    }

    return states;
  }

  private selectTheStateList() {
    const alreadySelectedStatesString = this.item.cells[this.fieldDefinition.key] && this.item.cells[this.fieldDefinition.key].value ?
      this.item.cells[this.fieldDefinition.key].value.states : '';

    if (alreadySelectedStatesString === '') {
      return;
    }
    const alreadySelectedStates = alreadySelectedStatesString.split(',');
    if (alreadySelectedStates.length > 0) {
      this.selectedStateList = alreadySelectedStates.map(value => {
        const trimmedValue = value.trim();
        return this.stateList.find(s => s.stateName === trimmedValue || s.stateCode === trimmedValue);
      });
    }
    this.emitOnValueChange();
  }

  shouldDisableOption(state: any) {
    return this.selectedStateList.map(s => s.stateName.toLowerCase()).indexOf(state.stateName.toLowerCase()) !== -1;
  }
}
